module.exports = "/_next/static/images/leaf-line-b724fdc136012072518f442d173d46dc.svg";